/**
 *
 * RegularLabel
 *
 */
import React from 'react';
import classnames from 'classnames';
import Label from '../../../../atoms/Label';

var RegularLabel = function RegularLabel(_ref) {
  var extraClasses = _ref.extraClasses,
      htmlFor = _ref.htmlFor,
      label = _ref.label,
      variation = _ref.variation;
  return React.createElement(React.Fragment, null, React.createElement(Label, {
    className: classnames("".concat(variation, "__label"), "".concat(variation, "__label--button"), extraClasses),
    htmlFor: htmlFor
  }), React.createElement(Label, {
    className: classnames("".concat(variation, "__label"), 'horizontal'),
    htmlFor: htmlFor
  }, label));
};

RegularLabel.defaultProps = {
  extraClasses: ''
};
export default RegularLabel;